import {useCallback, useEffect, useState} from 'react'
import {useHeaderBreadcrumb, useLayout} from '../../_metronic/layout/core'
import {Link, useLocation} from 'react-router-dom'
import clsx from 'clsx'
import {DefaultTitle} from '../../_metronic/layout/components/header/page-title/DefaultTitle'
import './selectCategory.css'
import {homeListCategoryTree} from '../modules/auth/core/_requests'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import {useIntl} from 'react-intl'

interface SelectCategoryType {
  id?: number
  parentId?: number
}

function SelectCategory({id, parentId}: SelectCategoryType) {
  const {classes, config} = useLayout()
  const {state} = useLocation()
  const {path}: any = state || {}
  const lang = useLang()
  const intl = useIntl()
  const {setChangeTitle, setChangeBeforeTitle, setReturnPath} = useHeaderBreadcrumb()

  const [lesson, setLesson] = useState<any>([])
  const [lessonName, setLessonName] = useState<any>([])
  const [lessonParentName, setLessonParentName] = useState<string>('')
  const [paths, setPaths] = useState<string[]>([])
  /*const list = [
    {
      id: 0,
      title: 'Physical Experiments',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      numberOfCourses: lesson.subList.length,
      courseDescription: 'Lessons',
      link: '/selectCategory/selectExperiment',
    },
    {
      id: 1,
      title: 'Lesson Plan',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      numberOfCourses: '1',
      courseDescription: 'Lessons',
      link: '/selectCategory',
    },
    {
      id: 2,
      title: 'Lesson Contents',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      numberOfCourses: '1',
      courseDescription: 'Lessons',
      link: '/selectCategory',
    },
    {
      id: 3,
      title: 'Question Bank',
      description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      numberOfCourses: '1',
      courseDescription: 'Lessons',
      link: '/selectCategory',
    },
  ]*/
  const getRandomColorClass = (index: number) => {
    const colors = ['bg-primary', 'bg-success', 'bg-danger', 'bg-warning', 'bg-info', 'bg-dark']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  const getList = useCallback(async () => {
    try {
      const {data} = await homeListCategoryTree(true, Number(id), 0, '', lang, '', '')

      setLesson(data[0])
    } catch (error) {
      console.error(error)
    }
  }, [id, lang])

  const getListName = useCallback(async () => {
    try {
      const {data} = await homeListCategoryTree(true, Number(id), 0, '', 'en', '', '')
      setLessonName(data[0])
    } catch (error) {
      console.error(error)
    }
  }, [id, lang])

  const getListParentName = useCallback(async () => {
    try {
      // const {data} = await homeListCategoryTree(true, Number(parentId), 0, '', lang, '', '')
      const {data} = await homeListCategoryTree(true, Number(parentId), 0, '', 'en', '', '')
      setLessonParentName(data[0]?.nodeAd)
    } catch (error) {
      console.error(error)
    }
  }, [parentId, lang])

  useEffect(() => {
    getList()
    getListName()
    getListParentName()
  }, [id])

  useEffect(() => {
    setChangeTitle(lesson?.nodeAd || '')
    setChangeBeforeTitle('')
    setReturnPath('')
  }, [lesson])

  function isEmpty(obj: any) {
    for (const key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        return true
      }
    }
    return false
  }

  useEffect(() => {
    if (isEmpty(lessonName)) {
      const allPaths: string[] = []
      const categoryPaths = generatePaths(lessonName)
      allPaths.push(...categoryPaths)
      setPaths(allPaths)
    }
  }, [lessonName])

  function convertToEnglishChars(str: string) {
    const turkishChars: {[key: string]: string} = {
      ı: 'i',
      ğ: 'g',
      ü: 'u',
      ş: 's',
      ö: 'o',
      ç: 'c',
      İ: 'I',
      Ğ: 'G',
      Ü: 'U',
      Ş: 'S',
      Ö: 'O',
      Ç: 'C',
    }

    return str.replace(/[^A-Za-z0-9_-]/g, (char) => {
      return turkishChars[char] || ''
    })
  }

  function generatePaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const path = `${prefix}/${convertToEnglishChars(
        node.nodeAd.toLowerCase().replace(/\s/g, '-')
      )}`

      if (node.subList) {
        node.subList.forEach((subNode: any) => {
          traverse(subNode, path)
        })
      } else {
        paths.push(path)
      }
    }

    traverse(data)
    return paths
  }

  return (
    <>
      {/*}
      <div className='toolbar py-2 px-0 ' id='kt_toolbar'>
        <div
          id='kt_toolbar_container'
          className={clsx(
            classes.toolbarContainer.join(' '),
            'd-flex align-items-center px-0 px-lg-8'
          )}
        >
          {config.pageTitle?.display && (
            <DefaultTitle changeBeforeTitle='' changeTitle={lesson?.nodeAd || ''} />
          )}
          <div className='flex-grow-1 flex-shrink-0 me-5'></div>
          <div className='d-flex align-items-center'>
            <Link
              to='/dashboard'
              className='btn btn-outline border-gray-600 btn-sm d-flex flex-center h-35px h-lg-40px'
            >
              Home<span className='d-none d-sm-inline ms-1'>Page</span>
            </Link>
          </div>
        </div>
      </div>
          {*/}
      <div className='row g-5 gx-xl-10 mt-md-n16 mt-2'>
        {/* Sol PEncere */}
        <div className='col-xxl-6 '>
          <div
            className='card card-flush h-100 bgi-no-repeat bgi-size-contain bgi-position-x-end mb-5 mb-xl-10 sal-animate full-height'
            style={{backgroundColor: '#F1416C'}}
            data-sal-delay='200'
            data-sal='slide-up'
            data-sal-duration='500'
          >
            <div className='card-header pt-5'>
              <div className='card-title d-flex flex-column'>
                {/* 👇 Lesson : Title 👇 */}
                <span className='fs-2hx fw-bold text-white lh-1 ls-n2'>
                  {intl.formatMessage({id: 'UNITSPAGE.LESSON'})}
                </span>
                {/* 👆 Lesson : Title 👆 */}
                <span className='text-white opacity-75 pt-2 fw-semibold fs-6'>
                  {lesson?.description}
                </span>

                <div className='flex-column mx-5 my-3'>
                  {/* begin::Item */}
                  {lesson?.subList?.map((item: any, index: number) => {
                    return (
                      <div key={index} className='d-flex align-items-center mb-4'>
                        {/* begin::Bullet */}
                        <span
                          className={`bullet bullet-vertical h-40px border border-white border-opacity-50 ${getRandomColorClass(
                            index
                          )}`}
                        />

                        <div className='form-check form-check-custom form-check-solid mx-5'></div>

                        <div className='flex-grow-1'>
                          <Link
                            // to='/selectCategory/selectExperiment/selectExperimentDetail'
                            to={`/units/${convertToEnglishChars(
                              lessonParentName.toLowerCase().replace(/\s/g, '-')
                            )}${paths[index]}`}
                            className='text-white fw-bold fs-6 link-primary'
                            state={{returnPath: path}}
                            onClick={() => window.localStorage.setItem('categoryId', item.id)}
                          >
                            {item.nodeAd}
                          </Link>
                        </div>
                      </div>
                    )
                  })}

                  {/* end:Item */}
                </div>

                <span className='fs-2 fw-bolder text-white lh-1 ls-n2 pt-8'>
                  {lesson?.subList?.length}
                  <span className='fw-normal ms-1'>
                    {lesson?.nodeAd} {intl.formatMessage({id: 'UNITSPAGE.EXPERIMENTS'})}
                  </span>
                </span>
              </div>
            </div>
            {/*}
            <div className='card-body d-flex align-items-end text-end pt-0 w-100'>
              <div className=' mt-3 w-100'>
                <Link
                  to={'/selectCategory/selectExperiment'}
                  state={{lesson}}
                  style={{backgroundColor: '#181c32', color: '#fff'}}
                  className='btn btn-dark'
                >
                  <i className='bi bi-eye fs-4'></i> View
                </Link>
              </div>
            </div>
            */}
          </div>
        </div>
        {/* Sol PEncere */}
        {/* Sağ PEncere */}
        <div className='col-xxl-6 min-h-100'>
          <div className='card card-flush h-md-100 sal-animate'>
            <div
              className='card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0'
              style={{
                backgroundPosition: '100% 50%',
                backgroundImage: 'url("media/stock/900x600/42.png")',
              }}
            >
              <div className='mb-10'>
                <div className='fs-2hx fw-bold text-gray-800 text-center mb-13'>
                  {/* 👇 Lesson Plan : Title 👇 */}
                  <span className='me-2'>
                    {intl.formatMessage({id: 'UNITSPAGE.LESSONPLAN'})}
                    <br />
                    <span className='text-dark opacity-75 pt-2 fw-semibold fs-6'>
                      {/*Lorem Ipsum is simply dummy text of the printing and typesetting industry.*/}
                    </span>
                  </span>
                  {/* 👆 Lesson Plan : Title 👆 */}
                </div>
                <div className='text-center'>
                  {/* 👇 View Plan : Title 👇 */}
                  <a
                    className='btn btn-sm btn-dark fw-bold'
                    // data-bs-toggle='modal'
                    //data-bs-target='#kt_modal_upgrade_plan'
                  >
                    {intl.formatMessage({id: 'UNITSPAGE.VIEWPLAN'})}
                  </a>
                  {/* 👆 View Plan : Title 👆 */}
                </div>
              </div>
              <img
                className='mx-auto h-150px h-lg-200px'
                src='assets/media/illustrations/misc/upgrade.svg'
                alt=''
              />
            </div>
          </div>
        </div>
        {/* Sağ PEncere */}
      </div>
    </>
  )
}

export default SelectCategory
